export default __webpack_public_path__ + "static/media/DouglasLopes_07.b52485f7.jpg";